export const PssRoutePath = {
  Prefix: "pss",
  Home: "/",

  // Authentication
  NotFoundError: "/404",
  InternalServerError: "/500",
  Login: "/login",
  ForgotPassword: "/forgot-password",

  // Dashboard
  Dashboard: "/dashboard",

  //Profile
  Profile: "/profile",
  ProfileAccount: "/profileAccount",

  // Compound Access
  CompoundAccessGate: "/compoundAccess/gate",
  CompoundAccessGateById: "/compoundAccess/gate/:gateId",
  CompoundAccessGateId: (gateId?: string) => `/compoundAccess/gate/${gateId}`,
  CompoundAccessHistoryLog: "/compoundAccess/historyLog",
  CompoundAccessHistoryLogPrint: "/compoundAccess/historyLog/print",
  CompoundAccessSuspiciousLog: "/compoundAccess/suspiciousLog",
  CompoundAccessSuspiciousLogPrint: "/compoundAccess/suspiciousLog/print",
  CompoundAccessManage: "/compoundAccess/manage",

  // Door Access
  DoorAccess: "/doorAccess",
  DoorAccessHistoryLog: "/doorAccessHistoryLog",
  DoorAccessManagement: "/doorAccessManagement",
  DoorAccessManagementDetails: `/doorAccessManagement/:doorId`,
  DoorAccessManagementDetailsById: (doorId?: string) =>
    `/doorAccessManagement/${doorId}`,

  // Access Group
  AccessGroup: "/accessGroup",
  UserGroup: "/usergroup",
  AccessGroupUserRegistration: "/accessGroup/userRegistration",
  AccessGroupUser: "/accessgroup/:userGroupId",
  AccessGroupUserAccount: "/accessGroup/:userGroupId/account",
  AccessGroupUserAccountById: (userGroupId?: string) =>
    `/accessGroup/${userGroupId}/account`,
  AccessGroupAccessRegistration: "/accessGroup/accessRegistration",
  AccessGroupAdd: "/accessGroup/add",

  // User Management
  UserManagement: "/userManagement",
  UserManagementRoleRegistration: "userManagement/roleRegistration",

  // Users Management / User:id / Role
  UserList: "/users/:userId/role",
  UserListById: (userId?: string) => `/users/${userId}/role`,

  // APRS
  // Attendance
  AprsAttendance: "/aprs/attendance",
  AprsAttendanceRecordRegister: "/aprs/attendance/registration",
  AprsAttendanceRecordEdit: "/aprs/attendance/edit",
  AprsAttendanceGeneral: "/aprs/general",
  AprsAttendanceGeneralPrint: "/aprs/general/print",
  AprsAttendanceOvertime: "/aprs/overtime",
  AprsAttendanceOvertimePrint: "/aprs/overtime/print",
  AprsAttendanceManage: "/aprs/manageAttendance",

  // Device Call
  DeviceCall: "/aprs/deviceCall",
  DeviceCallTablePrint: "/aprs/deviceCall/print",
  DeviceCallReportRegister: "/aprs/deviceCall/registration",
  DeviceCallPrint: "/aprs/deviceCall/:deviceCallId/printReport",
  DeviceCallPrintId: (deviceCallId?: string) =>
    `/aprs/deviceCall/${deviceCallId}/printReport`,
  DeviceCallDetail: "/aprs/deviceCall/:deviceCallId/details",
  DeviceCallId: (deviceCallId?: string) =>
    `/aprs/deviceCall/${deviceCallId}/details`,
  DeviceCallRecord: "/aprs/deviceCallRecord",
  DeviceCallRecordTablePrint: "/aprs/deviceCallRecord/print",
  DeviceCallRecordPrint: "/aprs/deviceCallRecord/:deviceCallId/printReport",
  DeviceCallRecordPrintId: (deviceCallId?: string) =>
    `/aprs/deviceCallRecord/${deviceCallId}/printReport`,
  DeviceCallRecordDetail: "/aprs/deviceCallRecord/:deviceCallId/details",
  DeviceCallRecordId: (deviceCallId?: string) =>
    `/aprs/deviceCallRecord/${deviceCallId}/details`,
  DeviceCallManage: "/aprs/manageDevice",

  // Vehicle
  VehicleInspection: "/aprs/vehicleInspection",
  VehicleInspectionDetail: "/aprs/vehicleInspection/details/:vehicleId",
  VehicleInspectionId: (vehicleId?: string) =>
    `/aprs/vehicleInspection/details/${vehicleId}`,
  VehicleInspectionPrint: "/aprs/vehicleInspection/details/print/:vehicleId",
  VehicleInspectionPrintId: (vehicleId?: string) =>
    `/aprs/vehicleInspection/details/print/${vehicleId}`,
  VehicleInspectionManage: "/aprs/manageVehicle",

  // UCUX
  Ucux: "/aprs/UcUx",
  UcuxPrintListPreview: "/aprs/UcUx/printPreview",
  UcuxHistoryDetail: "/aprs/UcUx/historyDetail",
  UcuxById: "/aprs/UcUx/:ucuxId",
  UcuxId: (ucuxId?: string) => `/aprs/UcUx/${ucuxId}`,
  UcuxPrintById: "/aprs/UcUx/printReport/:ucuxId",
  UcuxPrintId: (ucuxId?: string) => `/aprs/UcUx/printReport/${ucuxId}`,
  UcuxManage: "/aprs/manageUcUx",
  UcuxOffenseById: "/aprs/manageUcUx/:offenseId",
  UcuxOffenseId: (offenseId?: string) => `/aprs/manageUcUx/${offenseId}`,

  // References FAQ
  RefQuestion: "/aprs/references/FAQ",
  RefQuestionRegister: "/aprs/references/FAQ/register",
  RefQuestionAccount: "/aprs/references/FAQ/account",
  RefFAQById: "/aprs/references/FAQ/:FAQId/account",
  RefFAQId: (FAQId?: string) => `/aprs/references/FAQ/${FAQId}/account`,

  // Address
  RefAddressPhoneNo: "/aprs/references/addressPhoneNo",
  RefAddressPhoneNoRegister: "/aprs/references/addressPhoneNo/register",
  RefAddressPhoneNoAccount:
    "/aprs/references/addressPhoneNo/addPhoneNoId/account",
  RefAddressById: "/aprs/references/addressPhoneNo/:addPhoneNoId/account",
  RefAddPhoneNoId: (addPhoneNoId?: string) =>
    `/aprs/references/addressPhoneNo/${addPhoneNoId}/account`,

  //Company Vehicle
  RefCompanyVehicle: "/aprs/references/companyVehicle",

  RefCompanyVehicleAccount:
    "/aprs/references/companyVehicle/companyVehicleId/account",
  RefCompanyVehicleById:
    "/aprs/references/companyVehicle/:companyVehicleId/account",
  RefCompanyVehicleId: (companyVehicleId?: string) =>
    `/aprs/references/companyVehicle/${companyVehicleId}/account`,

  //Mfsp
  RefMfsp: "/aprs/references/MFSP",
  RefMfspRegister: "/aprs/references/MFSP/register",
  RefMfspAccount: "/aprs/references/MFSP/mfspId/account",
  RefMfspById: "/aprs/references/MFSP/:mfspId/account",
  RefMfspId: (mfspId?: string) => `/aprs/references/MFSP/${mfspId}/account`,
  //SOP
  RefSop:"/aprs/references/SOP",
  RefSopRegister: "/aprs/references/SOP/register",
    RefSopAccount: "/aprs/references/SOP/sopId/account",
  RefSopById: "/aprs/references/SOP/:sopId/account",
  RefSopId: (sopId?: string) => `/aprs/references/SOP/${sopId}/account`,


  //Police Law
  RefPoliceLaw: "/aprs/references/policeLaw",
  RefPoliceLawRegister: "/aprs/references/policeLaw/register",
  RefPoliceLawAccount: "/aprs/references/policeLaw/policeLawId/account",
  RefPoliceLawById: "/aprs/references/policeLaw/:policeLawId/account",
  RefPoliceLawId: (policeLawId?: string) =>
    `/aprs/references/policeLaw/${policeLawId}/account`,
  //Isps
  RefIsps: "/aprs/references/ISPS",
  RefIspsRegister: "/aprs/references/ISPS/detail/add",
  RefIspsAccount: "/aprs/references/ISPS/ispsId/detail/account",
  RefIspsById: "/aprs/references/ISPS/:ispsId/account",
  RefIspsId: (ispsId?: string) => `/aprs/references/ISPS/${ispsId}/account`,
  RefIspsDetail: "/aprs/references/ISPS/:ispsId/detail",
  RefIspsIdDetail: (ispsId?: string) =>
    `/aprs/references/ISPS/${ispsId}/detail`,
  

  //Profile
  LogoPicture: "/LogoPicture",

  //Assignee
  Assignee: "/aprs/assignee",

  //User Records
  UserRecords: "/aprs/userRecords",
  UserRecordsDetail: "/aprs/userRecords/details",

  //Vehicle Records
  VehicleRecords: "/aprs/vehicleRecords",
};
